import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TransactionsService } from 'src/app/services/http/transactions.services';
import * as TransactionsAction from '../actions/transactions.actions';
import { switchMap, catchError, mergeMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ITransactionSearchParam, ITransactionSearchResult } from 'src/app/models/transactions';
import { Action } from '@ngrx/store';
import * as systemActions from '../../system/actions/system.actions';
import { deduplicatingSwitchMap } from 'src/app/utils/deduplicatingSwitchMap';

@Injectable()
export class TransactionsEffects {

    constructor(private actions$: Actions, private transactionsServices: TransactionsService) { }

    getSecurityTransactions = createEffect(() => this.actions$.pipe(
        ofType<TransactionsAction.GetSecurityTransactions>(TransactionsAction.TransactionsActionTypes.GET_SECURITY_TRANSACTIONS),
        deduplicatingSwitchMap((action: TransactionsAction.GetSecurityTransactions) => {
            return this.getTransactionPipe(
                action.payload,
                (result) => new TransactionsAction.GetSecurityTransactionsSuccess(result),
                (errorMessage) => new TransactionsAction.SecurityTransactionsDataError(errorMessage)
            );
        })
    ))

    getRevenueTransactions$ = createEffect(() => this.actions$.pipe(
        ofType<TransactionsAction.GetRevenueTransactions>(TransactionsAction.TransactionsActionTypes.GET_REVENUE_TRANSACTIONS),
        deduplicatingSwitchMap((action: TransactionsAction.GetRevenueTransactions) => {
            return this.getTransactionPipe(
                action.payload,
                (result) => new TransactionsAction.GetRevenueTransactionsSuccess(result),
                (errorMessage) => new TransactionsAction.RevenueTransactionsDataError(errorMessage)
            );
        })
    ))

    getCashTransactions$ = createEffect(() => this.actions$.pipe(
        ofType<TransactionsAction.GetCashTransactions>(TransactionsAction.TransactionsActionTypes.GET_CASH_TRANSACTIONS),
        deduplicatingSwitchMap((action: TransactionsAction.GetCashTransactions) => {
            return this.getTransactionPipe(
                action.payload,
                (result) => new TransactionsAction.GetCashTransactionsSuccess(result),
                (errorMessage) => new TransactionsAction.CashTransactionsDataError(errorMessage)
            );
        })
    ));

    private getTransactionPipe(payload: ITransactionSearchParam, onSuccess: (result: ITransactionSearchResult) => Action, onFailure: (errorMessage: string) => Action) : Observable<any> {
        return this.transactionsServices.getPaginatedTransactions(payload)
            .pipe(
                switchMap((res: any) => {
                    if (res) {
                        if (res.errorMessage) {
                            return of(
                                onFailure(res.errorMessage)
                            );
                        } else {
                            const result: ITransactionSearchResult = this.createSearchResult(res, payload);
                            return of(
                                onSuccess(result)
                            );
                        }
                    }
                })
                , catchError((err) => {
                    return of(
                        onFailure(err.error.errorMessage)
                    );
                })
            );
    }
    private createSearchResult(resultData: any, searchParameters: ITransactionSearchParam): ITransactionSearchResult {
        return {
            transactionsList: resultData.data,
            asAtDate: searchParameters.toDate,
            fromDate: (searchParameters.fromDate) ? searchParameters.fromDate : null,
            clientEntityIds: searchParameters.entities,
            pagingInfo: resultData.pagination,
            accountType: searchParameters.accountType,
            totalItemCount: resultData.pagination.totalItemsCount
        } as ITransactionSearchResult;
    }
}
